module.exports = __webpack_public_path__ + "img/columbia-100-tablet_145137560b42be6fe3a233d15b7488da.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/img/columbia-100-tablet.jpg
// module id = 287
// module chunks = 0